import { compareByDue } from '@nedelnik/shared';

import { STATUS_LABELS } from '../sprint/labels.js';

import type { Task, TaskStatus } from '@nedelnik/shared';

/**
 * Список — те же задачи, что и на доске, но сгруппированные по статусам (3.1.2).
 *
 * Порядок групп — «в работе», «бэклог», «готово»: сверху то, чем занят сейчас,
 * внизу то, что уже закрыто. Это решение прототипа, и оно переносится дословно.
 */

const GROUP_ORDER: readonly TaskStatus[] = ['wip', 'backlog', 'done'];

export interface TaskGroup {
  status: TaskStatus;
  title: string;
  tasks: Task[];
}

/**
 * Внутри группы сортировка идёт по сроку (`compareByDue` из `shared`): задачи
 * со сроком выше задач без срока (3.6.6). Ручной порядок работает на доске, где
 * его и задают перетаскиванием.
 */
export function groupByStatus(
  tasks: readonly Task[],
  /**
   * Каким статусом показывать задачу. По умолчанию — её собственным; иначе
   * только что закрытая задача мгновенно уезжала бы в «Готово», и случайное
   * нажатие проходило бы незамеченным (3.1.8).
   */
  statusOf: (task: Task) => TaskStatus = (task) => task.status,
): TaskGroup[] {
  return GROUP_ORDER.map((status) => ({
    status,
    title: STATUS_LABELS[status],
    tasks: tasks.filter((task) => statusOf(task) === status).sort(compareByDue),
  })).filter((group) => group.tasks.length > 0);
}
